export default {
	lg:'ID',
	loginno:'Sesi login telah berakhir, silakan login kembali',
    cbdx:'Jumlah Pembatalan Karbon',
	cg:'Lampaui',
	yh:'Pengguna',
	pgb:'Peringkat',
	ryxz:'Lencana Kehormatan',
	jlmx:'Detail Catatan',
	lvsm:'Penjelasan Level',
	cbcy:'Kepemilikan Karbon',
	cbcy2:'Jumlah Aset Karbon',
	cbdixiaol:'Pembatalan Aset Karbon',
	cbdixiaol2:'Riwayat Pembatalan Aset Karbon',
	copylink:'Salin Tautan',
	fx:'Bagikan',
	xz:'Lencana',
	copyok:'Berhasil disalin',
	sys:'Hitung',
	jsjg:'Hasil Perhitungan',
	tpfw:'Emisi karbon Anda adalah',
	quxiao:'Batal',
	cbhx:'Hapus',
	qtrsj:'Silakan masukkan data',
	more:'Lebih',
	liuyue:'6 Bulan Terakhir',
	yinian:'1 Tahun Terakhir',
	wunian:'5 Tahun Terakhir',
	jiage:'Harga',
	click:'Klik di sini',
	sqtgqt:'Ajukan penitipan untuk aset karbon lainnya',
	sqxtqt:'Ajukan perwalian untuk aset karbon lainnya',
	zzsqtg:'Sedang mengajukan penitipan',
	zzsqxg:'Sedang mengajukan perwalian',
	zanwu:'Tidak ada data',
	pjno:'Nomor Proyek',
	pjtype:'Kategori Proyek',
	pjmc:'Nama Proyek',
	pjdate:'Tahun Proyek',
	pjid:'ID Proyek',
	num:'Jumlah',
	cbnums:'Jumlah Kredit Karbon',
	pjkssj:'Waktu Mulai Periode Penghitungan',
	pjjssj:'Waktu Berakhir Periode Penghitungan',
	datepx:'Urutkan berdasarkan Waktu',
	shengxu:'Naik',
	jiangxu:'Turun',
	sqtg:'Ajukan Penitipan Karbon',
	sqxg:'Ajukan Perwalian Karbon',
	sqtips:'Setelah mengajukan, kami akan menghubungi Anda dalam 2 hari kerja, yakin ingin mengajukan?',
	tips:'Tips',
	sq:'Ajukan',
	reset:'Atur Ulang',
	ok:'Konfirmasi',
	tj:'Kirim',
	ton:'Ton',
	shaixuan:'Saring',
	qtxqy:'Silakan isi nama perusahaan',
	qtxpjname:'Silakan isi nama penanggung jawab proyek',
	qtxem:'Silakan isi email',
	ems:'Email',
	qtxpjid:'Silakan isi ID Proyek',
	rzjg:'Lembaga Sertifikasi Aset Karbon',
	qtxxmbh:'Silakan isi nomor proyek',
	qtxpj:'Silakan isi nama proyek',
	qtxpjtype:'Silakan isi kategori proyek',
	qxzrygm:'Silakan pilih skala personel',
	qxz:'Silakan pilih',
	txynf:'Tahun Kredit Karbon',
	xmdate:'Pilih Tanggal',
	qtxxlh:'Silakan isi nomor seri kredit karbon',
	qtxnum:'Silakan isi jumlah (ton)',
	pjdata:'Tanggal Penghitungan Proyek',
	kssj:'Tanggal Mulai',
	jsrq:'Tanggal Berakhir',
	embzq:'Format email salah',
	fscode:'SMS berhasil dikirim',
	zsjl:'Riwayat Dijual',
	xjjl:'Riwayat Diturunkan',
	xiajias:'Turunkan',
	qrxiajia:'Konfirmasi untuk menurunkan?',
	xiajiaok:'Berhasil diturunkan',
	gmjl:'Riwayat Pembelian',
	buypj:'Beli',
	buypjname:'Proyek Pembelian',
	renbuy:'Orang telah membeli proyek ini',
	gjdq:'Negara/Wilayah',
	cyz:'Pemegang',
	buydate:'Tahun Pembelian',
	buynum:'Jumlah Pembelian',
	fkprise:'Jumlah Pembayaran',
	selljg:'Harga Jual',
	sell:'Jual',
	sellqj:'Rentang Harga Jual',
	
	zuidj:'Harga Terendah',
	zuigj:'Harga Tertinggi',
	sellnum:'Jumlah Penjualan',
	sellok:'Penjualan Berhasil',
	
	zyjytips:'Daftar Aset Karbon Perdagangan Bebas',
	czgl:'Manajemen Operasi',
	sellcb:'Jual Aset Karbon',
	jyjl:'Riwayat Transaksi',
	xiangq:'Detail',
	upapp1:'Ingin pengalaman interaktif yang lebih lengkap?',
	upapp2:'Kunjungi halaman seluler kami, nikmati hidup rendah karbon sekarang!',
	upapp3:'Pindai untuk akses mini program Toko Iklim',
	upapp4:'Siap untuk perjalanan rendah karbon?',
	upapp5:'Mari kurangi beban bumi bersama!',
	upapp6:'Hitung emisi karbon pribadi',
	upapp7:'Pelajari satu fakta karbon setiap hari',
	upapp8:'Jelajahi tema hijau, praktikkan konsep hijau',
	uppwd:'Ubah Kata Sandi',
	wjpwd:'Lupa Kata Sandi',
	area:'Kode Area',
	zhuce:'Daftar',
	qtxphone:'Silakan isi nomor telepon',
	qtxcode:'Silakan isi kode verifikasi',
	getcode:'Dapatkan Kode Verifikasi',
	xzarea:'Silakan pilih kode area',
	qtxnames:'Silakan isi nama',
	ydxy:'Saya telah membaca dan menyetujui',
	ydxy2:'Silakan baca perjanjian terlebih dahulu',
	yszc:'Kebijakan Privasi',
	and:'dan',
	fwxy:'Perjanjian Layanan',
	pwd:'Kata Sandi',
	login:'Login',
	outlogin:'Keluar',
	qtxpwd:'Silakan isi kata sandi',
	qtxpwd2:'Silakan masukkan kata sandi lagi',
	qtxpwd3:'Kata sandi tidak cocok',
	djjr:'Klik untuk masuk',
	loading:'Fitur sedang dikembangkan, harap tunggu',
	backhome:'Kembali ke Beranda',
	backs:'Kembali',
	mycb:'Akun Karbon Saya',
	myinfo:'Informasi Saya',
	lxwm:'Hubungi Kami',
	zcok:'Pendaftaran Berhasil',
	buypr:'Jumlah Pembayaran',
	mybuy:'Bayar dengan Saldo',
	buynotips:'Saldo tidak cukup, gunakan metode lain',
	myye:'Saldo saat ini',
	zfbbuy:'Bayar dengan Alipay',
	buybtn:'Bayar',
	buyno:'Pesanan tidak normal, silakan coba lagi',
	buytips:'Tips: Setelah pembayaran berhasil, tidak ada pengembalian dana, harap berhati-hati.',
	buyok:'Pembayaran Berhasil',
	buyoktips:'Proyek aset karbon akan tiba dalam 10 menit, Anda akan menerima SMS, harap tunggu',
	buyfail:'Pembayaran Gagal',
	sbtips:`
		<div>Silakan periksa masalah berikut:</div>
		<div>1. Pembayaran dibatalkan</div>
		<div>2. Saldo tidak cukup, pastikan saldo mencukupi</div>
		<div>3. Jumlah pembayaran melebihi batas pembayaran online</div>
		<div>4. Anda belum mengaktifkan pembayaran online, aktifkan terlebih dahulu.</div>
	`,
	myzhuce:'Pendaftaran Individu',
	qiyezhuce:'Pendaftaran Perusahaan',
	
	
	
	
	tpfl:'Emisi Karbon',
	dxfs:'Metode Pembatalan',
	dxtip1:'Dukung Proyek Ramah Lingkungan',
	dxtip2:'Gunakan saldo kredit karbon akun',
	shengyu:'Sisa',
	pjdj:'Harga Satuan Proyek',
	pjcheck:'Pemilihan Proyek',
	mycbcy:'Jumlah Kepemilikan',
	mycbcy2:'Jumlah kepemilikan tidak cukup',
	dxok:'Pembatalan Berhasil',
	dximg:'Poster Pembatalan',
	dxbtn:'Hapus',
	xzjiadian:'Silakan pilih peralatan',
	pfgj:'Total emisi karbon',
	mxrx:'Rincian sebagai berikut',
	syb:'Sebelumnya',
	xyb:'Selanjutnya',
	tdxtips:'Jumlah pembatalan tidak boleh 0',
	
	xzhxtype:'Silakan pilih jenis industri',
	xzaddress:'Pilih Wilayah',
	xtxqyncz:'Silakan isi nilai produksi tahunan perusahaan',
	wanyuan:'Ribu Yuan',
	xzdate:'Silakan pilih waktu',
	qtxwz:'Silakan lengkapi informasi',
	jbxx:'Informasi Dasar',
	qtxschool:'Silakan isi nama sekolah',
	qtxschooltype:'Silakan pilih jenis sekolah',
	qtxjzmj:'Silakan isi luas bangunan',
	qtxssrs:'Silakan isi jumlah guru & murid',
	
	jtrk:'Jumlah anggota keluarga',
	zfmj:'Silakan pilih luas hunian',
	gusuan:'Perkiraan',
	jingsuan:'Perhitungan Akurat',
    unit: 'Jumlah Orang',
	jbts:'Silakan isi jumlah hari acara',
	cbrs:'Silakan isi jumlah peserta',
	gzrs:'Silakan isi jumlah penonton',
	kpj:'Harga Pembukaan',
	zjs:'Penyelesaian Kemarin',
	zgj:'Harga Tertinggi',
	zdj:'Harga Terendah',
	gsgr:'Nama Perusahaan/Individu',
	leix:'Jenis',
	diqu:'Wilayah',
	tzc:'Aset Karbon',
	riqis:'Tanggal',
	zt:'Status',
	xwzx:'Berita',
	wtlx:'Jenis Masalah',
	qxzwtlx:'Silakan pilih jenis masalah',
	qmscxdwt:'Silakan deskripsikan masalahnya',
	lxfs:'Silakan isi kontak',
	wt1:'Fungsi Tidak Normal',
	wt2:'Saran Produk',
	wt3:'Masalah Lainnya',
	lv:'Level',
	chenhao:'Gelar',
	ywc:'Selesai',
	wwc:'Belum Selesai',
	phb:'Peringkat Pembatalan Karbon',
	gxsj:'Waktu Pembaruan',
	paim:'Peringkat',
	toux:'Foto Profil',
	yhu:'Nama Pengguna',
	shijian:'Waktu',
	qitas:'Lainnya',
	y:'Pakaian',
	s:'Makanan',
	z:'Tempat Tinggal',
	x:'Transportasi',
	y:'Penggunaan',
	lquzs:'Ajukan Sertifikat',
	xzleix:'Pilih Jenis',
	name:'Nama',
	qtxname:'Silakan isi nama asli',
	zsphone:'Nomor Telepon',
	dzzs:'Sertifikat Elektronik Saja',
	dzandzzzs:'Elektronik + Sertifikat Fisik',
	ssq:'Provinsi/Kota/Kabupaten',
	address:'Alamat',
	xxaddress:'Silakan isi alamat lengkap',
	zsleix:'Jenis Sertifikat',
	slgz:'Aturan Pengajuan',
	ltgm:'Warga Nol Karbon',
	ltqy:'Perusahaan Nol Karbon',
	dataisnonono:'Gagal memuat data, silakan refresh',
	tjok:'Berhasil Dikirim',
	tjoktips:'Berhasil dikirim, sertifikat akan diterbitkan dalam 3 hari kerja',
	cbisno:'Jumlah pembatalan Anda tidak cukup, tidak dapat menerima',
	zhengshu:'sertifikat',
	tgjl:'Riwayat Manajemen Aset Karbon',
	tgl:'Jumlah Penitipan',
	xtl:'Jumlah Perwalian',
	wdzs:'Sertifikat Saya',
	dxliang:'Jumlah Pembatalan',
	hexl:'Jumlah Verifikasi',
	getriqi:'Tanggal Perolehan',
	xzzs:'Unduh Sertifikat',
	lquzzzs:'Ambil Sertifikat Fisik',
	sqrq:'Tanggal Pengajuan',
	dsh:'Menunggu Ditinjau',
	shcg:'Disetujui',
	shwtg:'Ditolak',
	caozuo:'Operasi',
	tiqu:'Ambil',
	tiqunum:"Jumlah Pengambilan (ton)",
	txtzh:'Silakan isi akun karbon Anda',
	chakanjil:'Lihat Riwayat',
	zhuanzeng:'Hibah Aset Karbon',
	zhuanz:'Hibahkan',
	zhuanznum:'Jumlah Hibah',
	dfphone:'Silakan masukkan nomor telepon penerima',
	zhuanzok:'Hibah Berhasil',
	zhuanzjil:'Riwayat Hibah Aset Karbon',
	zzlx:'Jenis Hibah',
	zhuanc:'Transfer Keluar',
	zhuanr:'Transfer Masuk',
	wozzg:'Saya menghibahkan ke',
	zzgw:'Dihibahkan ke saya',
	chsq:'Tarik Pengajuan',
	qdchehui:'Yakin ingin menarik pengajuan?',
	hxipt:'Silakan masukkan nama individu/nama perusahaan',
	hxipt2:'Silakan masukkan tujuan pembatalan',
	hdcg:'Pembatalan Berhasil',
	cyrq:'Tanggal Kepemilikan',
	wdqb:'Dompet Saya',
	yue:'Saldo',
	yuemx:'Rincian Saldo',
	jymx:'Riwayat Transaksi',
	tixian:'Penarikan',
	czhi:'Isi Saldo',
	tixiantips1:'Biaya layanan penarikan adalah',
	tixiantips2:'Setelah mengajukan penarikan, kami akan menghubungi Anda dalam 3 hari kerja',
	qsypnzf:'Silakan gunakan Paynow',
	skzh:'Akun Penerima',
	czje:'Jumlah Pengisian',
	zftips:'Tips: Setelah pembayaran, unggah bukti pembayaran untuk verifikasi',
	scimg:'Silakan unggah bukti',
	scimgtips:'Format gambar hanya jpg, jpeg, png atau gif',
	zzsqz:'Sedang mengajukan',
	txje:'Jumlah Penarikan',
	jine:'Jumlah',
	laiyuan:'Sumber',
	jydh:'Nomor Transaksi',
	jylx:'Jenis Transaksi',
	sxf:'Biaya Layanan',
	genghuan:'Ganti',
	xiugais:'Ubah',
	save:'Simpan',
	updphone:'Ganti Nomor Telepon',
	jrtj:'Harga Karbon Hari Ini',
    cjsl:'Jumlah Transaksi',
    cjje:'Transaksi uang',
    qqhg:'Pasar Kepatuhan Global',
    qqzy:'Pasar Sukarela Global',
}